"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppSettings = exports.SyncSettings = exports.EventSubscriptionsOverrides = exports.EventSubscriptionSettings = exports.CompressionSettings = exports.FeatureSettings = exports.FeatureFlagStatus = void 0;
var createStringMapSerializers_1 = __importDefault(require("../common/createStringMapSerializers"));
var json2typescript_1 = require("json2typescript");
var FeatureFlagStatus;
(function (FeatureFlagStatus) {
    FeatureFlagStatus["Enabled"] = "enabled";
})(FeatureFlagStatus = exports.FeatureFlagStatus || (exports.FeatureFlagStatus = {}));
var FeatureSettings = (function () {
    function FeatureSettings(partial) {
        this.enabled = undefined;
        this.immutable = undefined;
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('enabled', [String], true),
        __metadata("design:type", Array)
    ], FeatureSettings.prototype, "enabled", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('immutable', [String], true),
        __metadata("design:type", Array)
    ], FeatureSettings.prototype, "immutable", void 0);
    FeatureSettings = __decorate([
        (0, json2typescript_1.JsonObject)('FeatureSettings'),
        __metadata("design:paramtypes", [Object])
    ], FeatureSettings);
    return FeatureSettings;
}());
exports.FeatureSettings = FeatureSettings;
var CompressionSettings = (function () {
    function CompressionSettings(partial) {
        this.type = undefined;
        this.level = undefined;
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('type', String, true),
        __metadata("design:type", String)
    ], CompressionSettings.prototype, "type", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('level', Number, true),
        __metadata("design:type", Number)
    ], CompressionSettings.prototype, "level", void 0);
    CompressionSettings = __decorate([
        (0, json2typescript_1.JsonObject)('CompressionSettings'),
        __metadata("design:paramtypes", [Object])
    ], CompressionSettings);
    return CompressionSettings;
}());
exports.CompressionSettings = CompressionSettings;
var EventSubscriptionSettings = (function () {
    function EventSubscriptionSettings(partial) {
        this.batchSize = undefined;
        this.cursorBatchSize = undefined;
        this.distributedTriggerEventProcessingEnabled = undefined;
        this.limiterMaxTokenCount = undefined;
        this.limiterRateSec = undefined;
        this.maxRetryMinutes = undefined;
        this.throttleDocumentSizeThresholdBytes = undefined;
        this.unorderedBatchSize = undefined;
        this.unorderedBatchTimeoutSec = undefined;
        this.compression = undefined;
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('batch_size', Number, true),
        __metadata("design:type", Number)
    ], EventSubscriptionSettings.prototype, "batchSize", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('cursor_batch_size', Number, true),
        __metadata("design:type", Number)
    ], EventSubscriptionSettings.prototype, "cursorBatchSize", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('distributed_trigger_event_processing_enabled', Boolean, true),
        __metadata("design:type", Boolean)
    ], EventSubscriptionSettings.prototype, "distributedTriggerEventProcessingEnabled", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('limiter_max_token_count', Number, true),
        __metadata("design:type", Number)
    ], EventSubscriptionSettings.prototype, "limiterMaxTokenCount", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('limiter_rate_sec', Number, true),
        __metadata("design:type", Number)
    ], EventSubscriptionSettings.prototype, "limiterRateSec", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('max_retry_minutes', Number, true),
        __metadata("design:type", Number)
    ], EventSubscriptionSettings.prototype, "maxRetryMinutes", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('throttle_document_size_threshold_bytes', Number, true),
        __metadata("design:type", Number)
    ], EventSubscriptionSettings.prototype, "throttleDocumentSizeThresholdBytes", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('unordered_batch_size', Number, true),
        __metadata("design:type", Number)
    ], EventSubscriptionSettings.prototype, "unorderedBatchSize", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('unordered_batch_timeout_sec', Number, true),
        __metadata("design:type", Number)
    ], EventSubscriptionSettings.prototype, "unorderedBatchTimeoutSec", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('compression', CompressionSettings, true),
        __metadata("design:type", CompressionSettings)
    ], EventSubscriptionSettings.prototype, "compression", void 0);
    EventSubscriptionSettings = __decorate([
        (0, json2typescript_1.JsonObject)('EventSubscriptionSettings'),
        __metadata("design:paramtypes", [Object])
    ], EventSubscriptionSettings);
    return EventSubscriptionSettings;
}());
exports.EventSubscriptionSettings = EventSubscriptionSettings;
var EventSubscriptionsOverrides = (function () {
    function EventSubscriptionsOverrides(partial) {
        this.eventSubscriptionID = undefined;
        this.batchSize = undefined;
        this.cursorBatchSize = undefined;
        this.distributedTriggerEventProcessingEnabled = undefined;
        this.limiterMaxTokenCount = undefined;
        this.limiterRateSec = undefined;
        this.maxRetryMinutes = undefined;
        this.throttleDocumentSizeThresholdBytes = undefined;
        this.unorderedBatchSize = undefined;
        this.unorderedBatchTimeoutSec = undefined;
        this.compression = undefined;
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('event_subscription_id', String, true),
        __metadata("design:type", String)
    ], EventSubscriptionsOverrides.prototype, "eventSubscriptionID", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('batch_size', Number, true),
        __metadata("design:type", Number)
    ], EventSubscriptionsOverrides.prototype, "batchSize", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('cursor_batch_size', Number, true),
        __metadata("design:type", Number)
    ], EventSubscriptionsOverrides.prototype, "cursorBatchSize", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('distributed_trigger_event_processing_enabled', Boolean, true),
        __metadata("design:type", Boolean)
    ], EventSubscriptionsOverrides.prototype, "distributedTriggerEventProcessingEnabled", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('limiter_max_token_count', Number, true),
        __metadata("design:type", Number)
    ], EventSubscriptionsOverrides.prototype, "limiterMaxTokenCount", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('limiter_rate_sec', Number, true),
        __metadata("design:type", Number)
    ], EventSubscriptionsOverrides.prototype, "limiterRateSec", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('max_retry_minutes', Number, true),
        __metadata("design:type", Number)
    ], EventSubscriptionsOverrides.prototype, "maxRetryMinutes", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('throttle_document_size_threshold_bytes', Number, true),
        __metadata("design:type", Number)
    ], EventSubscriptionsOverrides.prototype, "throttleDocumentSizeThresholdBytes", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('unordered_batch_size', Number, true),
        __metadata("design:type", Number)
    ], EventSubscriptionsOverrides.prototype, "unorderedBatchSize", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('unordered_batch_timeout_sec', Number, true),
        __metadata("design:type", Number)
    ], EventSubscriptionsOverrides.prototype, "unorderedBatchTimeoutSec", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('compression', CompressionSettings, true),
        __metadata("design:type", CompressionSettings)
    ], EventSubscriptionsOverrides.prototype, "compression", void 0);
    EventSubscriptionsOverrides = __decorate([
        (0, json2typescript_1.JsonObject)('EventSubscriptionsOverrides'),
        __metadata("design:paramtypes", [Object])
    ], EventSubscriptionsOverrides);
    return EventSubscriptionsOverrides;
}());
exports.EventSubscriptionsOverrides = EventSubscriptionsOverrides;
var SyncSettings = (function () {
    function SyncSettings(partial) {
        this.changesetIntegrationTimeoutSecs = undefined;
        this.changesetIntegrationMaxAttempts = undefined;
        this.changesetIntegrationUpperBoundBytes = undefined;
        this.changesetIntegrationUpperBoundCount = undefined;
        this.downloadLoopSleepMillis = undefined;
        this.translatorSteadyStateBatchSize = undefined;
        this.translatorDownloadBytesThreshold = undefined;
        this.translatorMaxNumUnsyncableDocs = undefined;
        this.translatorNumClientMetas = undefined;
        this.translatorPBSConnectionPoolSize = undefined;
        this.translatorDownloadBackpressureThresholdBytes = undefined;
        this.translatorDownloadBackpressureThresholdCount = undefined;
        this.translatorChangestreamCursorBatchSize = undefined;
        this.numInstructionsBeforeBootstrapFlush = undefined;
        this.appPartitionCompactionTimeoutSec = undefined;
        this.appPartitionCompactionLVTBuildTimeout = undefined;
        this.maxChangesetBytesWrittenPerCompaction = undefined;
        this.maxChangesetEntriesModifiedPerCompaction = undefined;
        this.initialSyncMaxDocsPerScan = undefined;
        this.initialSyncMaxSecondsPerScan = undefined;
        this.initialSyncMaxDocBytesPerScan = undefined;
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('changeset_integration_timeout_secs', Number, true),
        __metadata("design:type", Number)
    ], SyncSettings.prototype, "changesetIntegrationTimeoutSecs", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('changeset_integration_max_attempts', Number, true),
        __metadata("design:type", Number)
    ], SyncSettings.prototype, "changesetIntegrationMaxAttempts", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('changeset_integration_upper_bound_bytes', Number, true),
        __metadata("design:type", Number)
    ], SyncSettings.prototype, "changesetIntegrationUpperBoundBytes", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('changeset_integration_upper_bound_count', Number, true),
        __metadata("design:type", Number)
    ], SyncSettings.prototype, "changesetIntegrationUpperBoundCount", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('download_loop_sleep_millis', Number, true),
        __metadata("design:type", Number)
    ], SyncSettings.prototype, "downloadLoopSleepMillis", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('translator_batch_size', Number, true),
        __metadata("design:type", Number)
    ], SyncSettings.prototype, "translatorSteadyStateBatchSize", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('translator_download_bytes_threshold', Number, true),
        __metadata("design:type", Number)
    ], SyncSettings.prototype, "translatorDownloadBytesThreshold", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('translator_max_num_unsyncable_docs', Number, true),
        __metadata("design:type", Number)
    ], SyncSettings.prototype, "translatorMaxNumUnsyncableDocs", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('translator_num_client_metas', Number, true),
        __metadata("design:type", Number)
    ], SyncSettings.prototype, "translatorNumClientMetas", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('translator_pbs_conn_pool_size', Number, true),
        __metadata("design:type", Number)
    ], SyncSettings.prototype, "translatorPBSConnectionPoolSize", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('translator_download_backpressure_threshold_bytes', Number, true),
        __metadata("design:type", Number)
    ], SyncSettings.prototype, "translatorDownloadBackpressureThresholdBytes", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('translator_download_backpressure_threshold_count', Number, true),
        __metadata("design:type", Number)
    ], SyncSettings.prototype, "translatorDownloadBackpressureThresholdCount", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('translator_changestream_cursor_batch_size', Number, true),
        __metadata("design:type", Number)
    ], SyncSettings.prototype, "translatorChangestreamCursorBatchSize", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('num_instructions_before_bootstrap_flush', Number, true),
        __metadata("design:type", Number)
    ], SyncSettings.prototype, "numInstructionsBeforeBootstrapFlush", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('app_partition_compaction_timeout_sec', Number, true),
        __metadata("design:type", Number)
    ], SyncSettings.prototype, "appPartitionCompactionTimeoutSec", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('app_partition_compaction_lvt_build_timeout_sec', Number, true),
        __metadata("design:type", Number)
    ], SyncSettings.prototype, "appPartitionCompactionLVTBuildTimeout", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('max_changeset_bytes_written_per_compaction', Number, true),
        __metadata("design:type", Number)
    ], SyncSettings.prototype, "maxChangesetBytesWrittenPerCompaction", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('max_changeset_entries_modified_per_compaction', Number, true),
        __metadata("design:type", Number)
    ], SyncSettings.prototype, "maxChangesetEntriesModifiedPerCompaction", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('initial_sync_max_docs_per_scan', Number, true),
        __metadata("design:type", Number)
    ], SyncSettings.prototype, "initialSyncMaxDocsPerScan", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('initial_sync_max_seconds_per_scan', Number, true),
        __metadata("design:type", Number)
    ], SyncSettings.prototype, "initialSyncMaxSecondsPerScan", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('initial_sync_max_doc_bytes_per_scan', Number, true),
        __metadata("design:type", Number)
    ], SyncSettings.prototype, "initialSyncMaxDocBytesPerScan", void 0);
    SyncSettings = __decorate([
        (0, json2typescript_1.JsonObject)('SyncSettings'),
        __metadata("design:paramtypes", [Object])
    ], SyncSettings);
    return SyncSettings;
}());
exports.SyncSettings = SyncSettings;
var eventSubscriptionSettingsMapSerializers = (0, createStringMapSerializers_1.default)(EventSubscriptionSettings);
var EventSubscriptionSettingsMapConverter = (function () {
    function EventSubscriptionSettingsMapConverter() {
        this.serialize = eventSubscriptionSettingsMapSerializers.serialize;
        this.deserialize = eventSubscriptionSettingsMapSerializers.deserialize;
    }
    EventSubscriptionSettingsMapConverter = __decorate([
        json2typescript_1.JsonConverter
    ], EventSubscriptionSettingsMapConverter);
    return EventSubscriptionSettingsMapConverter;
}());
var AppSettings = (function () {
    function AppSettings(partial) {
        this.connectionPoolSize = undefined;
        this.features = undefined;
        this.eventSubscriptions = undefined;
        this.eventSubscriptionsOverrides = undefined;
        this.syncSettings = undefined;
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('connection_pool_size', Number, true),
        __metadata("design:type", Number)
    ], AppSettings.prototype, "connectionPoolSize", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('features', FeatureSettings, true),
        __metadata("design:type", FeatureSettings)
    ], AppSettings.prototype, "features", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('event_subscriptions', EventSubscriptionSettingsMapConverter, true),
        __metadata("design:type", Object)
    ], AppSettings.prototype, "eventSubscriptions", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('event_subscriptions_overrides', EventSubscriptionsOverrides, true),
        __metadata("design:type", EventSubscriptionsOverrides)
    ], AppSettings.prototype, "eventSubscriptionsOverrides", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('sync_settings', SyncSettings, true),
        __metadata("design:type", SyncSettings)
    ], AppSettings.prototype, "syncSettings", void 0);
    AppSettings = __decorate([
        (0, json2typescript_1.JsonObject)('AppSettings'),
        __metadata("design:paramtypes", [Object])
    ], AppSettings);
    return AppSettings;
}());
exports.AppSettings = AppSettings;
//# sourceMappingURL=AppSettings.js.map